import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector:'paginationGadget',
  template:`
    <a class="btn btn-outline-info dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      {{this.selectedResultsPerPage}}
    </a>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
      <li class="dropdown-item" style="list-style: none" value="1" (click)="onSelected($event)">1</li>
      <li class="dropdown-item" style="list-style: none" value="5" (click)="onSelected($event)">5</li>
      <li class="dropdown-item" style="list-style: none" value="10" (click)="onSelected($event)">10</li>
      <li class="dropdown-item" style="list-style: none" value="15" (click)="onSelected($event)">15</li>
      <li class="dropdown-item" style="list-style: none" value="25" (click)="onSelected($event)">25</li>
      <li class="dropdown-item" style="list-style: none" value="50" (click)="onSelected($event)">50</li>
      <li class="dropdown-item" style="list-style: none" value="75" (click)="onSelected($event)">75</li>
      <li class="dropdown-item" style="list-style: none" value="100" (click)="onSelected($event)">100</li>
    </div>
  `
})

export class PaginationGadgetComponent {

  @Input() selectedResultsPerPage=25;
  @Output() changeValue:EventEmitter<number>= new EventEmitter();

  onSelected($event: any) {
    this.selectedResultsPerPage = $event.target.value;
    this.changeValue.emit(this.selectedResultsPerPage);
  }
}
